(() => {
  const root = document.documentElement;
  const markProductPage = () => {
    const main = document.querySelector('main');
    const productInfo = main?.querySelector('product-info[id^="MainProduct-"]');
    if (!main || !productInfo) return;

    root.classList.add('rb-product-motion-page');
    root.classList.remove('rb-product-motion-ready');
    main.querySelectorAll('.rb-motion-reveal, .rb-motion-visible').forEach((section) => {
      section.classList.remove('rb-motion-reveal', 'rb-motion-visible');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markProductPage, { once: true });
  } else {
    markProductPage();
  }

  document.addEventListener('shopify:section:load', markProductPage);
})();
